require('./hireCardVirtualCreditSuccess.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @ helpers
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;
const PersonalDataHelper = require('utilities/personalDataHelper');
const { formatAmountObject } = require('utilities/currencyHelper');
const { getLastNChars } = require('utilities/stringHelper');
const HireSuccessStepCardImage = require('components/cards/hireSuccessStepCardImage/hireSuccessStepCardImage');

//@commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKLink } = require('commonsComponents/OKLink');
const { OKMessage } = require('commonsComponents/OKMessage');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');

// @constants
const { PENDING } = require('constants/hireCardSubmitScenarios');
const {
    CARD_PAYMENT_METHOD_UNIQUE,
    CARD_PAYMENT_METHOD_FIXED,
    CARD_PAYMENT_METHOD_VARIABLE,
    EURO_SYMBOL,
    EURO_TEXT,
    PERCENTAGE_SYMBOL
} = require('constants/index');
const { catalogue, analyticsId } = require('../analytics/hireCardVirtualCreditAnalytics');

class HireCardVirtualCreditSuccess extends React.Component {

    checkIsPendingStatus() {
        const { immHireCardVirtualCredit } = this.props;
        return immHireCardVirtualCredit.get('hiringStatus') === PENDING;
    }

    buildSummary() {
        const {
            immAccount,
            immHireCardNameSelector,
            immHireCreditLimit,
            immHirePaymentMethod,
        } = this.props;

        const limitObj = {
            amount: immHireCreditLimit.get('creditLimit'),
            currency: EURO_TEXT
        };

        const paymentMethod = {
            [CARD_PAYMENT_METHOD_UNIQUE]: `${formatText('hireCardVirtualCredit-hireCardVirtualCredit_summaryMethodOfPaymentFullPay')}`,
            [CARD_PAYMENT_METHOD_FIXED]: `${formatText('hireCardVirtualCredit-hireCardVirtualCredit_summaryMethodOfPaymentDeferredFixedFee')}`,
            [CARD_PAYMENT_METHOD_VARIABLE]: `${formatText('hireCardVirtualCredit-hireCardVirtualCredit_summaryMethodOfPaymentDeferredVariableFee')}`
        };

        const paymentMethodType = immHirePaymentMethod.get('type');
        const paymentMethodText = paymentMethod[paymentMethodType];
        const paymentMethodSymbol = paymentMethodType === CARD_PAYMENT_METHOD_FIXED ? EURO_SYMBOL : PERCENTAGE_SYMBOL;
        const paymentMethodValue = paymentMethodType === CARD_PAYMENT_METHOD_UNIQUE ? paymentMethodText :
            `${paymentMethodText} ${immHirePaymentMethod.get('value')} ${paymentMethodSymbol}`;

        const accountIban = getLastNChars(immAccount.get('iban'));

        return (
            <div className="row hire-card-virtual-credit-success__summary">
                <div className="col-xs-6 hire-card-virtual-credit-success__summary-left-column">
                    <FormattedText
                        className="col-xs-12 hire-card-virtual-credit-success__summary-title"
                        value="hireCardVirtualCredit-hireCardVirtualCredit_summarySelectedName"
                    />
                    <div className="col-xs-12 hire-card-virtual-credit-success__summary-value">
                        {immHireCardNameSelector.getIn(['names', immHireCardNameSelector.get('selectedIndex')])}
                    </div>
                    <FormattedText
                        className="col-xs-12 hire-card-virtual-credit-success__summary-title"
                        value="hireCardVirtualCredit-hireCardVirtualCredit_summarySelectedLimit"
                    />
                    <OneLineSymbolAmount
                        amountObject={limitObj}
                        amountObjectFormatted={formatAmountObject(limitObj, true)}
                        className="col-xs-12 hire-card-virtual-credit-success__summary-value"
                        language={getLanguage()}
                        trimDecimals={true}
                    />
                </div>
                <div className="col-xs-5 col-xs-offset-1">
                    <FormattedText
                        className="col-xs-12 hire-card-virtual-credit-success__summary-title"
                        value="cardDetails-associatedAccount"
                    />
                    <div className="col-xs-12 hire-card-virtual-credit-success__summary-value">
                        {`${immAccount.get('alias')} ${accountIban}`}
                    </div>
                    <FormattedText
                        className="col-xs-12 hire-card-virtual-credit-success__summary-title"
                        value="hireCardVirtualCredit-hireCardVirtualCredit_summaryPaymentMethod"
                    />
                    <div className="col-xs-12 hire-card-virtual-credit-success__summary-value">
                        {paymentMethodValue}
                    </div>
                </div>
            </div>
        );
    }

    buildTexts() {
        let titleKey = 'hireCardVirtualCredit-hireCardVirtualCredit_successTitleCompleted';
        let textElement = (
            <div className="col-xs-8 hire-card-virtual-credit-success__text">
                <FormattedText value="hireCardVirtualCredit-hireCardVirtualCredit_successText1Completed" />
            </div>
        );

        if (this.checkIsPendingStatus()) {
            titleKey = 'hireCardVirtualCredit-hireCardVirtualCredit_successTitlePending';
            textElement = (
                <div className="col-xs-8 hire-card-virtual-credit-success__text">
                    <FormattedText value="hireCardVirtualCredit-hireCardVirtualCredit_successText1Pending" />
                    <div className="hire-card-virtual-credit-success__pending-text">
                        <FormattedText
                            value="hireCardVirtualCredit-hireCardVirtualCredit_errorTextCallUs2"
                        />
                    </div>
                    <div className="hire-card-virtual-credit-success__phone">
                        <i className="hire-card-virtual-credit-error__phone-icon icon icon-s-llamar" />
                        <FormattedText value="hireCardVirtualCredit-phoneNumberClients" />
                    </div>
                </div>
            );
        }

        return {
            textElement,
            titleKey
        };
    }

    buildMessage() {
        const { immProfile } = this.props;
        const email = PersonalDataHelper.getEmail(immProfile);
        const url = formatText('hireCardVirtualCredit-hireCardVirtualCredit_successWarningUrl2');
        let message = (
            <FormattedText
                value="hireCardVirtualCredit-hireCardVirtualCredit_successWarningTextUpdateEmail"
            />
        );
        let policyCardText = (
            <div className="hire-card-virtual-credit-success__message-warning-text">
                <FormattedText value="hireCardVirtualCredit-hireCardVirtualCredit_successWarningText1" />
                &nbsp;
                <OKLink modifier="inline" target="_blank" to={url}>
                    <FormattedText value="hireCardVirtualCredit-hireCardVirtualCredit_successWarningText2" />
                </OKLink>
                &nbsp;
                <FormattedText value="hireCardVirtualCredit-hireCardVirtualCredit_successWarningText3" />
                &nbsp;
                &nbsp;
            </div>
        );

        if (!!email) {
            policyCardText = '';
            message = (
                <div className="hire-card-virtual-credit-success__message-paragraph">
                    <FormattedText
                        injectedStrings={[email]}
                        value="hireCardVirtualCredit-hireCardVirtualCredit_successWarningTextSentByEmail1"
                    />
                    &nbsp;
                    <OKLink modifier="inline" target="_blank" to={url}>
                        <FormattedText
                            value="hireCardVirtualCredit-hireCardVirtualCredit_successWarningTextSentByEmail2"
                        />
                    </OKLink>
                    &nbsp;
                    <FormattedText
                        value="hireCardVirtualCredit-hireCardVirtualCredit_successWarningTextSentByEmail3"
                    />
                </div>
            );
        }

        return (
            <div className="col-xs-12">
                <OKMessage type="informative">
                    {policyCardText}
                    {message}
                </OKMessage>
            </div>
        );
    }

    render() {
        const {
            immHireCardImageSelector,
            immProfile,
            processDetail
        } = this.props;
        let content;

        if (immProfile.get('isFetching')) {
            content = <LoadingSection />;
        } else {
            const { textElement, titleKey } = this.buildTexts();
            const messageSection = this.buildMessage();
            const summarySection = this.buildSummary();
            const selectedImageId = immHireCardImageSelector.get('selectedImageId');
            const immImageData = immHireCardImageSelector.getIn(['imagesById', selectedImageId]);
            const wizardSuccessIcon = this.checkIsPendingStatus() ? 'pending' : '';
            const goBackButton = {
                label: (
                    <FormattedText
                        value="hireCardVirtualCredit-hireCardVirtualCredit_errorBackButtonText"
                    />
                ),
                url: '/myprofile/cards'
            };

            content = (
                <WizardSuccess
                    iconModifier={wizardSuccessIcon}
                    mainButton={goBackButton}
                    processDetail={processDetail}
                    successMessage={formatText(titleKey)}
                    tealium={catalogue[analyticsId.VIRTUAL_CREDIT_CARD_WIZARD_SUCCESS]({ productName: processDetail })}
                    isSecondVersion
                >
                    <article className="hire-card-virtual-credit-success">
                        <div className="row">
                            <HireSuccessStepCardImage
                                className="col-xs-4 hire-card-virtual-credit-success__card-image"
                                immImageData={immImageData}
                            />
                            {textElement}
                        </div>
                        {summarySection}
                        <div className="row hire-card-virtual-credit-success__message">
                            {messageSection}
                        </div>
                    </article>
                </WizardSuccess>
            );
        }
        return content
    }
}

HireCardVirtualCreditSuccess.propTypes = {
    immAccount: PropTypes.object.isRequired,
    immHireCardImageSelector: PropTypes.object.isRequired,
    immHireCardNameSelector: PropTypes.object.isRequired,
    immHireCardVirtualCredit: PropTypes.object.isRequired,
    immHireCreditLimit: PropTypes.object.isRequired,
    immHirePaymentMethod: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    processDetail: PropTypes.string
};

module.exports = HireCardVirtualCreditSuccess;
